import { Box, Text } from '@chakra-ui/react';

export const ReferralFooter = () => (
  <Box mt={20} borderTop="1px" borderColor="#E1E9EF" pb={2}>
    <Text fontSize="xs" color="#777A7C">
      * Dados internos da Inventa. Grande maioria dos fornecedores registrou
      esse movimento. Não é uma promessa de vendas.
    </Text>
    <Text fontSize="xs" color="#777A7C">
      ** Válido para primeira compra do lojista na Inventa com pedido mínimo
      acima de R$600
    </Text>
    <Text fontSize="xs" color="#777A7C">
      *** Comissão conforme mínimo previsto em contrato, nem sempre 0%
    </Text>
  </Box>
);
